"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSnapOrigin = void 0;
exports.defaultSnapOrigin = (_a = process.env.SNAP_ORIGIN) !== null && _a !== void 0 ? _a : `npm:@leapwallet/metamask-cosmos-snap`;
//# sourceMappingURL=config.js.map